import {
  type OnboardingConfig,
  type ParseIssue,
  type ParseResult,
  parseOnboardingConfig,
} from '@xhubio-saas/core-frontend/plugin-onboarding-yaml'
import setupYamlDe from './setup.de.yaml?raw'
import setupYamlEn from './setup.en.yaml?raw'

/**
 * Parse both onboarding YAMLs at module load. A bad YAML is a build-time
 * failure — the app will not start. The parser surfaces line/column info.
 */
function parseOrFail(yaml: string, locale: string): OnboardingConfig {
  const result: ParseResult = parseOnboardingConfig(yaml)
  if (!result.ok) {
    throw new Error(
      `[onboarding] setup.${locale}.yaml invalid:\n${result.errors
        .map((e: ParseIssue) => `  ${e.path}: ${e.message}`)
        .join('\n')}`
    )
  }
  return result.data
}

export const onboardingConfigs = {
  de: parseOrFail(setupYamlDe, 'de'),
  en: parseOrFail(setupYamlEn, 'en'),
}

export type OnboardingLocale = keyof typeof onboardingConfigs
